import React from "react";
import PropTypes from "prop-types";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import sampledialogcancel from "src/Assets/images/Add.png";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import sendanemail from "src/Assets/images/sendemail.svg";
import PostMessageValidation from "./PostMessageValidation";

function SendEmailDialog(props) {
  const { onClose, open, mailRestrictionsStatus, onActionSuccess } = props;
  const handleClose = () => {
    onClose();
  };
  return (
    <Modal
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      sx={{
        zIndex: 4000,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          outline: "none",
          boxShadow: 24,
          minWidth: 300,
        }}
      >
        <div className={feedstyles.sampledialogcountandcancel}>
          {mailRestrictionsStatus === "N" ? (
            <div></div>
          ) : (
            <p className={feedstyles.reportheading}>
              <b>Send email </b>
            </p>
          )}
          <a onClick={handleClose}>
            <img src={sampledialogcancel} />
          </a>
        </div>

        <div>
          {mailRestrictionsStatus === "N" ? (
            <p>{`${props.displayName} is not accepting emails`}</p>
          ) : (
            <PostMessageValidation
              messageType={"sendaMail"}
              displayName={props.displayName}
              id={props.id}
              onClose={handleClose}
              onActionSuccess={onActionSuccess}
            />
          )}
        </div>
      </Box>
    </Modal>
  );
}

SendEmailDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function ReusuableSendaMailModal(props) {
  const [open, setOpen] = React.useState(false);
  const {onActionSuccess} = props;
  const handleClickOpen = (id) => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const notificationStatusArray = props?.notificationStatus
    ? props.notificationStatus.split(",")
    : [];

  const isLightColor = notificationStatusArray[8] === "N";

  return (
    <>
      <div
        onClick={(e) => {
          if (e && e.stopPropagation) e.stopPropagation();
          handleClickOpen(props.id);
        }}
        key={props.id}
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          height: "100%",
          cursor: "pointer",
          padding: "0.375rem 1.5rem", boxSizing: "border-box", whiteSpace: "nowrap"
        }}
      >
        <img src={sendanemail} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="" />
        <span style={{ fontSize: 14, whiteSpace: "nowrap", color: isLightColor ? "#888" : "#000"  }}>
          Send email to {props.displayName}
        </span>
      </div>

      <SendEmailDialog
        open={open}
        onClose={handleClose}
        id={props.id}
        displayName={props.displayName}
        mailRestrictionsStatus={notificationStatusArray[8] || ""}
        onActionSuccess={onActionSuccess}
      />
    </>
  );
}
